



























































































import { Component, Prop, Vue } from "vue-property-decorator";
import Monitoring24JamIcuPage from "@/components/pemeriksaan/icu-hcu/Monitoring24JamIcuPage.vue";
import KriteriaHcuPage from "@/pages/pemeriksaan_ranap/KriteriaHcuPage.vue";
import KriteriaIccuPage from "@/pages/pemeriksaan_ranap/KriteriaIccuPage.vue";
import KriteriaIcuPage from "@/pages/pemeriksaan_ranap/KriteriaIcuPage.vue";
//  KriteriaKeluarIntensifPage di-hide sementara atas permintaan user
// (digantikan Kriteria Keluar per-modalitas). Import dibiarkan agar mudah diaktifkan lagi.
// import KriteriaKeluarIntensifPage from "../tabs/rekam-medis/icu-hcu/KriteriaKeluarIntensifPage.vue";

@Component({
	components: {
		KriteriaHcuPage,
		KriteriaIcuPage,
		KriteriaIccuPage,
		Monitoring24JamIcuPage,
	},
})
export default class IcuHcuPage extends Vue {
	@Prop() register!: number;
	@Prop() rm!: number;
	@Prop({ default: false }) isActive!: boolean;
	//  IGD hanya memakai kriteria masuk/keluar IRI; monitoring 24 jam tetap di Ranap
	@Prop({ default: true }) showMonitoring!: boolean;

	mainTab = "masuk";
	subMasuk = "icu";
	subKeluar = "icu";
}
